import { CstICMS, error99, NaturezaOperacao, RetAPI } from '../../Utils/Types'
import { Api } from '../../Utils/api'
import { v4 as uuid } from 'uuid'
import { encode as base64_encode } from 'base-64'

export type NatOpAttributes = {
    natOp: NaturezaOperacao,
    cstListDentro: CstICMS[],
    cstListFora: CstICMS[],
}

export const NaturezaOperacaoService = {

    GetAttributes: async (id?: string): Promise<RetAPI> => {

        const resp = await Api('NatOp/attributes', 'get', { id })
        const attributes: NaturezaOperacao = {
            id: 0,
            descricao: '',
            cfop_entrada: '',
            cfop_saida: '',
            cfop_interno: '',
            cfop_externo: '',
            cst_dentro: '',
            cst_fora: '',
            id_user_insert: 0,
            id_user_last_update: 0,
            id_user_exclusao: 0,
            dt_cadastro: '',
            dt_last_update: '',
            dh_exclusao: '',
            name_user_insert: '',
            name_user_last_update: '',
            name_user_delete: ''
        }

        let retorno: NatOpAttributes = { natOp: attributes, cstListDentro: [], cstListFora: [] }

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {

                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: retorno
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                if (resp.data.natOp) {

                    attributes.id = resp.data.natOp.id
                    attributes.descricao = resp.data.natOp.descricao
                    attributes.cfop_entrada = resp.data.natOp.cfop_entrada
                    attributes.cfop_saida = resp.data.natOp.cfop_saida
                    attributes.cfop_interno = resp.data.natOp.cfop_interno
                    attributes.cfop_externo = resp.data.natOp.cfop_externo
                    attributes.cst_dentro = resp.data.natOp.cst_dentro
                    attributes.cst_fora = resp.data.natOp.cst_fora

                    attributes.id_user_insert = resp.data.natOp.id_user_insert
                    attributes.id_user_last_update = resp.data.natOp.id_user_last_update
                    attributes.id_user_exclusao = resp.data.natOp.id_user_exclusao

                    attributes.dt_cadastro = resp.data.natOp.dt_cadastro
                    attributes.dt_last_update = resp.data.natOp.dt_last_update
                    attributes.dh_exclusao = resp.data.natOp.dh_exclusao

                    attributes.name_user_insert = resp.data.natOp.name_user_insert
                    attributes.name_user_last_update = resp.data.natOp.name_user_last_update
                    attributes.name_user_delete = resp.data.natOp.name_user_delete

                    retorno.natOp = attributes

                }

                if (resp.data.cst_dentro_list) {
                    retorno.cstListDentro = resp.data.cst_dentro_list.map((item: any) => {
                        return {
                            id: item.cod_cst,
                            cod_cst: item.cod_cst,
                            description: item.descricao,
                        }
                    })
                }

                if (resp.data.cst_fora_list) {
                    retorno.cstListFora = resp.data.cst_fora_list.map((item: any) => {
                        return {
                            id: item.cod_cst,
                            cod_cst: item.cod_cst,
                            description: item.descricao,
                        }
                    })
                }
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: retorno
            }
        }

        return {
            error: false,
            data: retorno
        }

    },

    Save: async (naturezaOperacao: any): Promise<RetAPI> => {

        let id = ''

        if (naturezaOperacao.id) {
            id = naturezaOperacao.id.toString()
        }

        const resp = await Api('NatOp/save', 'post', {

            descricao: naturezaOperacao.descricao,
            cfop_entrada: naturezaOperacao.cfop_entrada,
            cfop_saida: naturezaOperacao.cfop_saida,
            cfop_interno: naturezaOperacao.cfop_interno,
            cfop_externo: naturezaOperacao.cfop_externo,
            cst_dentro: naturezaOperacao.cst_dentro,
            cst_fora: naturezaOperacao.cst_fora,
            id

        })

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    field: resp.data.field
                }
            }

            return {
                error: false,
                msg: 'Dados da natureza de operação gravados com sucesso',
                id: resp.data.natureza.id,
                data: resp.data,
                dt_cadastro: resp.data.natureza.dt_cadastro,
                dt_last_update: resp.data.natureza.dt_last_update,
                name_user_insert: resp.data.natureza.name_user_insert,
                name_user_last_update: resp.data.natureza.name_user_last_update,
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }
    },

    Delete: async (idExcluir: number, motivo: string, senha: string): Promise<RetAPI> => {

        const random = uuid()

        senha = base64_encode(senha + '-' + random)

        const resp = await Api(`NatOp/delete?id=${idExcluir}&motivo=${motivo}&senha=${senha}`, 'delete')

        if (!resp.data) {
            return {
                error: true,
                msg: "Nenhuma informação retornada"
            }
        }

        if (resp.data.error && resp.data.error === '99') {
            error99()
        }

        if (resp.data.error && resp.data.error === '1') {
            return {
                error: true,
                msg: resp.data.msg || ''
            }
        }

        return {
            error: false,
            msg: '',
        }

    },

    Filter: async (field: string, filter_type: string, filter: string, id?: string): Promise<RetAPI> => {

        const resp = await Api('NatOp/filter', 'get', { field, filter_type, filter, id })
        const naturezaOperacao: NaturezaOperacao[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: naturezaOperacao
                }
            }

            if (resp.data.error && resp.data.error === '0') {
                
                resp.data.naturezas.map((item: any) => {
                    return naturezaOperacao.push({

                        id: item.id,
                        descricao: item.descricao,
                        cfop_entrada: item.cfop_entrada,
                        cfop_saida: item.cfop_saida,
                        cfop_interno: item.cfop_interno,
                        cfop_externo: item.cfop_externo,
                        cst_dentro: item.cst_dentro,
                        cst_fora: item.cst_fora,

                        id_user_insert: item.id_user_insert,
                        id_user_last_update: item.id_user_last_update,
                        id_user_exclusao: item.id_user_exclusao,
                        dt_cadastro: item.dt_cadastro,
                        dt_last_update: item.dt_last_update,
                        dh_exclusao: item.dh_exclusao,
                        name_user_insert: item.name_user_insert,
                        name_user_last_update: item.name_user_last_update,
                        name_user_delete: item.name_user_delete

                    })
                })

            }

        } else {
            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: naturezaOperacao
            }
        }

        return {
            error: false,
            data: naturezaOperacao
        }
    },

    Relatorio: async (datai: string, dataf: string, descricao?: string, mostrar_excluidas?: string): Promise<RetAPI> => {

        const resp = await Api('NatOp/Report/relatorio', 'get', { datai, dataf, descricao, mostrar_excluidas })
        const natOp: any[] = []

        if (resp.data) {

            if (resp.data.error && resp.data.error === '99') {
                error99()
            }

            if (resp.data.error && resp.data.error === '1') {
                return {
                    error: true,
                    msg: resp.data.msg || '',
                    data: natOp
                }
            }

            if (resp.data.error && resp.data.error === '0') {

                resp.data.nat_op.map((item: any) => {
                    return natOp.push({

                        id: item.id,
                        id_user_exclusao: item.id_user_exclusao,
                        dh_exclusao: item.dh_exclusao,
                        motivo_exclusao: item.motivo_exclusao,
                        name_user_delete: item.name_user_delete,
                        descricao: item.descricao,

                    })
                })
            }

        } else {

            return {
                error: true,
                msg: "Nenhuma informação retornada",
                data: natOp
            }
        }

        return {
            error: false,
            data: natOp,
        }
    }
}
